/**
 * @generated SignedSource<<9d6f6d105c86f51778c0a2fa9b923e80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddCompanyToFeatureFlagCohortInput = {
  cohortId?: string | null;
  companyId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type addCompanyToFeatureFlagCohortMutation$variables = {
  input: AddCompanyToFeatureFlagCohortInput;
};
export type addCompanyToFeatureFlagCohortMutation$data = {
  readonly AddCompanyToFeatureFlagCohort: {
    readonly missionControlData: {
      readonly id: string;
      readonly featureFlagLists: {
        readonly id: string;
        readonly cohorts: ReadonlyArray<{
          readonly id: string;
          readonly cohortId: number | null;
          readonly name: string | null;
          readonly companyIds: ReadonlyArray<number | null> | null;
        } | null> | null;
        readonly alwaysLastCompanyIds: ReadonlyArray<number | null> | null;
      } | null;
    } | null;
  } | null;
};
export type addCompanyToFeatureFlagCohortMutation = {
  variables: addCompanyToFeatureFlagCohortMutation$variables;
  response: addCompanyToFeatureFlagCohortMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddCompanyToFeatureFlagCohortPayload",
    "kind": "LinkedField",
    "name": "AddCompanyToFeatureFlagCohort",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlDataType",
        "kind": "LinkedField",
        "name": "missionControlData",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlFeatureFlagListsType",
            "kind": "LinkedField",
            "name": "featureFlagLists",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlFeatureFlagCohortType",
                "kind": "LinkedField",
                "name": "cohorts",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cohortId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alwaysLastCompanyIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addCompanyToFeatureFlagCohortMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addCompanyToFeatureFlagCohortMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f6eb45eaa7b591559e5e9b29134cf308",
    "id": null,
    "metadata": {},
    "name": "addCompanyToFeatureFlagCohortMutation",
    "operationKind": "mutation",
    "text": "mutation addCompanyToFeatureFlagCohortMutation(\n  $input: AddCompanyToFeatureFlagCohortInput!\n) {\n  AddCompanyToFeatureFlagCohort(input: $input) {\n    missionControlData {\n      id\n      featureFlagLists {\n        id\n        cohorts {\n          id\n          cohortId\n          name\n          companyIds\n        }\n        alwaysLastCompanyIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7476101c6c8dd8ef8fc56967380e2eca";

export default node;
